import { render, staticRenderFns } from "./qyyx_service.vue?vue&type=template&id=9a2a1088&scoped=true"
import script from "./qyyx_service.vue?vue&type=script&lang=js"
export * from "./qyyx_service.vue?vue&type=script&lang=js"
import style0 from "./qyyx_service.vue?vue&type=style&index=0&id=9a2a1088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2a1088",
  null
  
)

export default component.exports